import script from "./SameDesign.vue?vue&type=script&setup=true&lang=js"
export * from "./SameDesign.vue?vue&type=script&setup=true&lang=js"

import "./SameDesign.vue?vue&type=style&index=0&id=6502afd6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6502afd6"]])

export default __exports__